/**
 * elementIdの要素までスクロールする関数
 * @param elementId 要素のid
 */
export const jumpUpToElement = (elementId: string) => {
  const tableElement = document.getElementById(elementId);
  tableElement?.scrollIntoView(true);
};
